<template>
    <div>
        <div class="banner">
            <div>
                <h3>氨气泄漏检测胶带</h3>
                <p>新型氨气泄漏检测方式</p>
            </div>
        </div>
        <div class="content">
            <div class="common-title" id="title0">
                <div :class="{ 'introduct': true, 'fadeInUp': content0_title_animation }">
                    <div class="commit-tit">
                        <h3>产品介绍</h3>
                        <div class="small-text">Product introduction</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content0">
                <div v-show="content0_content_animation"
                    :class="{ 'img-parent': true, 'fadeInLeft': this.content0_content_animation }">
                    <img class="img" :src="t1" />
                </div>
                <div v-show="content0_content_animation"
                    :class="{ 'img-parent': true, 'fadeInRight': content0_content_animation }">
                    <p>
                        氨气泄漏检测胶带是一种用于检测氨气泄漏的特殊胶带。它通常由聚合物材料制成，具有高度吸附氨气的能力。氨气泄漏检测胶带的使用非常简便。当怀疑有氨气泄漏时，将胶带贴附在可能泄漏的区域，如管道接口、阀门或容器表面。胶带会吸附氨气，如果泄漏存在，胶带的颜色会发生变化，由白色变为紫色，以示警示。
                    </p>
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title5">
                    <div v-show="content5_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content5_title_animation }">
                        <div class="commit-tit">
                            <h3>产品特性</h3>
                            <div class="small-text">Product Characteristics</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content5">
                    <div v-show="content5_content_animation" :class="{ 'fadeInUp': content5_content_animation }"
                        style="width: 100%;text-align: center;">
                        <table>
                            <tr>
                                <td>易定性：和一般的胶带一样可以粘贴使用的检测方式，通过变色来告知泄漏;</td>
                            </tr>
                            <tr>
                                <td>检测浓度：可检测200ppm氨气(空气中，流量110ml/min.);</td>
                            </tr>
                            <tr>
                                <td>环境耐受性：可使用于广泛的温度范围，(-20℃~80℃、更低温未测试)具有耐候性，可在室外使用(推荐6个月);</td>
                            </tr>
                            <tr>
                                <td>易清除，无残留：剥离时胶水残留不易发生，如果发生，也比较容易去除;</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="common-title" id="title1">
                <div :class="{ 'introduct': true, 'fadeInUp': content1_title_animation }">
                    <div class="commit-tit">
                        <h3>产品结构</h3>
                        <div class="small-text">Product Mix</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content1">
                <div v-show="content1_content_animation"
                    :class="{ 'img-parent': true, 'fadeInLeft': this.content1_content_animation }">
                    <ul>
                        <li>01》0.050mmPET离型层</li>
                        <li>02》含有可检测氨气的硅系粘着剂</li>
                        <li>03》PET基材0.025mm</li>
                    </ul>
                </div>
                <div v-show="content1_content_animation"
                    :class="{ 'img-parent': true, 'fadeInRight': content1_content_animation }">
                    <img class="img" :src="t5" />
                    <p style="color: #999999;width: 360px;line-height: 40px;font-size:14px;text-align:center;">总厚度：0.075mm（去除离型层）</p>
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title2">
                    <div v-show="content2_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content2_title_animation }">
                        <div class="commit-tit">
                            <h3>环境耐受性</h3>
                            <div class="small-text">Environmental Tolera</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content2">
                    <div v-show="content2_content_animation" :class="{ 'fadeInUp': content2_content_animation }"
                        style="width: 100%;">
                        <table>
                            <thead>
                                <tr>
                                    <th>环境</th>
                                    <th>保存条件</th>
                                    <th>保存后是否变色</th>
                                    <th>保存后、氨气暴露变色</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>高温</td>
                                    <td>60℃X6个月</td>
                                    <td>无变色</td>
                                    <td>暴露部分变成紫色</td>
                                </tr>
                                <tr>
                                    <td>低温</td>
                                    <td>-5℃X6个月</td>
                                    <td>无变色</td>
                                    <td>暴露部分变成紫色</td>
                                </tr>
                                <tr>
                                    <td>高湿度</td>
                                    <td>40℃X95%RHX6个月</td>
                                    <td>无变色</td>
                                    <td>暴露部分变成紫色</td>
                                </tr>
                                <tr>
                                    <td>户外</td>
                                    <td>美国佛罗里达室外暴露6个月</td>
                                    <td>无变色</td>
                                    <td>暴露部分变成紫色</td>
                                </tr>
                                <tr>
                                    <td>水浸渍</td>
                                    <td>室温水浸渍3个月</td>
                                    <td>无变色</td>
                                    <td>暴露部分变成紫色</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="common-title" id="title3">
                <div v-show="content3_title_animation" :class="{ 'introduct': true, 'fadeInUp': content3_title_animation }">
                    <div class="commit-tit">
                        <h3>使用步骤</h3>
                        <div class="small-text">Usage Steps</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content3">
                <div v-show="content3_content_animation" :class="{ 'fadeInUp': content3_content_animation }"
                    style="width: 100%;text-align: center;">
                    <ul>
                        <li>
                            <img :src="t4" alt="">
                            <p>确定可能发生泄漏的部位除去表面的灰尘等污垢</p>
                        </li>
                        <li>
                            <img :src="t2" alt="">
                            <p>用检测胶带覆盖接头极力制造封闭空间</p>
                        </li>
                        <li>
                            <img :src="t3" alt="">
                            <p>定期确认有无变色当颜色变成蓝色/紫色时说明发生了氨水泄漏</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title4">
                    <div v-show="content4_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content4_title_animation }">
                        <div class="commit-tit">
                            <h3>使用案例</h3>
                            <div class="small-text">Use Cases</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content4">
                    <div v-show="content4_content_animation" :class="{ 'fadeInUp': content4_content_animation }"
                        style="width: 100%;">
                        <ul>
                            <li> <img class="img" :src="s1" />
                                <p>管道</p>
                            </li>
                            <li> <img class="img" :src="s2" />
                                <p>接缝</p>
                            </li>
                            <li> <img class="img" :src="s3" />
                                <p>接缝</p>
                            </li>
                            <li> <img class="img" :src="s4" />
                                <p>法兰</p>
                            </li>
                            <li> <img class="img" :src="s5" />
                                <p>接头</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
// 导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
    name: 'Safesystem',
    components: {

        // import引入的组件需要注入到对象中才能使用
    },
    data() {
        return {
            t1: require("@/assets/img/an/t1.png"),
            t2: require("@/assets/img/an/t2.png"),
            t3: require("@/assets/img/an/t3.png"),
            t4: require("@/assets/img/an/t4.png"),
            t5: require("@/assets/img/an/t5.png"),
            s1: require("@/assets/img/an/s1.png"),
            s2: require("@/assets/img/an/s2.png"),
            s3: require("@/assets/img/an/s3.png"),
            s4: require("@/assets/img/an/s4.png"),
            s5: require("@/assets/img/an/s5.png"),
            dui: require("@/assets/img/safe/dui.png"),
            activeName: '',
            content0_title_animation: false, content0_content_animation: false,
            content1_title_animation: false, content1_content_animation: false,
            content2_title_animation: false, content2_content_animation: false,
            content3_title_animation: false, content3_content_animation: false,
            content4_title_animation: false, content4_content_animation: false,
            content5_title_animation: false, content5_content_animation: false,
            list: [
                require("@/assets/img/qtape/k1.png"),
                require("@/assets/img/qtape/k2.png"),
                require("@/assets/img/qtape/k3.png"),
                require("@/assets/img/qtape/k4.png"),
                require("@/assets/img/qtape/k5.png")
            ]
        }
    },
    created() {
        window.onscroll = false;
    },
    mounted() {
        this.$nextTick(() => {
            this.scroll();
            window.addEventListener('scroll', this.scroll)
        })
    },
    methods: {
        scroll() {
            var a = [1, 2, 3];
            const docScrollTop = document.documentElement.scrollTop - 175;

            const title0_elOffsetTop = document.getElementById("title0").offsetTop;
            const content0_elOffsetTop = document.getElementById("content0").offsetTop;
            if (title0_elOffsetTop >= docScrollTop && title0_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content0_title_animation = true;
            }
            if (content0_elOffsetTop >= docScrollTop && content0_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content0_content_animation = true;
            }

            const title1_elOffsetTop = document.getElementById("title1").offsetTop;
            const content1_elOffsetTop = document.getElementById("content1").offsetTop;
            if (title1_elOffsetTop >= docScrollTop && title1_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content1_title_animation = true;
            }
            if (content1_elOffsetTop >= docScrollTop && content1_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content1_content_animation = true;
            }
            const title2_elOffsetTop = document.getElementById("title2").offsetTop;
            const content2_elOffsetTop = document.getElementById("content2").offsetTop;
            if (title2_elOffsetTop >= docScrollTop && title2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content2_title_animation = true;
            }
            if (content2_elOffsetTop >= docScrollTop && content2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content2_content_animation = true;
            }
            const title3_elOffsetTop = document.getElementById("title3").offsetTop;
            const content3_elOffsetTop = document.getElementById("content3").offsetTop;
            if (title3_elOffsetTop >= docScrollTop && title3_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content3_title_animation = true;
            }
            if (content3_elOffsetTop >= docScrollTop && content3_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content3_content_animation = true;
            }
            const title4_elOffsetTop = document.getElementById("title4").offsetTop;
            const content4_elOffsetTop = document.getElementById("content4").offsetTop;
            if (title4_elOffsetTop >= docScrollTop && title4_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content4_title_animation = true;
            }
            if (content4_elOffsetTop >= docScrollTop && content4_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content4_content_animation = true;
            }
            const title5_elOffsetTop = document.getElementById("title5").offsetTop;
            const content5_elOffsetTop = document.getElementById("content5").offsetTop;
            if (title5_elOffsetTop >= docScrollTop && title5_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content5_title_animation = true;
            }
            if (content5_elOffsetTop >= docScrollTop && content5_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content5_content_animation = true;
            }

        },
        mouseEnter(item) {
            console.log(item)
            this.activeName = item.target.dataset.name;
        }
        ,
        mouseOut() {
            this.activeName = ''
        }

    },
}
</script>

<style scoped lang="less">
@keyframes an1 {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

@-webkit-keyframes an1

/* Safari 与 Chrome */
    {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

.fixd {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: space-Between;
    -webkit-justify-content: space-Between;
    -moz-box-pack: space-Between;
    -ms-flex-pack: space-Between;
    justify-content: space-Between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.fadeInUp {
    animation: fadeInUp 1s;
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
}

.fadeInRight {
    animation: fadeInRight 1s;
    -webkit-animation-name: fadeInRight;
    animation-name: fadeInRight;
}

.fadeInLeft {
    animation: fadeInLeft 1s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft0 {
    animation: fadeInLeft 1.2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft1 {
    animation: fadeInLeft 1.4s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft2 {
    animation: fadeInLeft 1.6s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft3 {
    animation: fadeInLeft 1.8s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft4 {
    animation: fadeInLeft 2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.title {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
}

.banner {
    background: url('~@/assets/img/an/banner.png') no-repeat;
    background-size: 100% 100%;
   
}

.content {
    .common-title {
        text-align: center;
        margin-bottom: 53px;
    }

    .common-content {
        .fixd();
        align-items: center;

        >div:first-child {
            width: 42%;
        }

        >div:last-child {
            width: 42%;
        }

        .text {
            font-size: 14px;
            line-height: 24px;
            color: #666;
            margin-top: 25px;
            text-align: justify;

        }
    }
}

#content1 {
    ul {
        margin-left: 30%;

        li {
            height: 40px;
            color: #999999;
            font-size: 1.8rem;
        }
    }
}

#content0 {
    p {
        line-height: 30px;
    }

}

#content2 {
    table {
        width: 100%;
        background-color: #fff;
        border-radius: 4px;
        text-align: left;
        tr {
            line-height: 45px;

            td:first-child {
                text-align: center;
            }

            td:last-child {
                text-align: left;
            }
        }

        tr:nth-child(odd) {
            background-color: #e6f3ff;
        }
        tr:nth-child(even) {
            background-color:  #F5FAFF;
        }
        thead {
            th {
                color: #fff;
                background-color: #2a8ceb;
                text-align: left;
            }

            th:first-child {
                width: 35%;
                text-align: center;
                border-top-left-radius: 4px;
            }

            th:last-child {
                text-align: left;
                border-top-right-radius: 4px;
            }
        }
    }

    p {
        width: 80%;
        margin: 0 auto;
        margin-top: 20px;
    }
}

#content3 {
    ul {
        display: flex;
        justify-content: space-between;

        li {
            width: 30%;
            text-align: center;

            p {
                width: 80%;
                margin: 0 auto;
                margin-top: 20px;
                line-height: 30px;
                font-size: 16px;
            }
        }
    }
}

#content4 {
    ul {
        display: flex;
        justify-content: space-between;

        li {
            width: 19%;
            text-align: center;

            p {
                color: #fff;
                width: 60%;
                margin: 0 auto;
                margin-top: -40px;
                line-height: 30px;
            }
        }
    }
}

#content5 {
    table {
        width: 100%;
        text-align: left;

        tr {
            line-height: 45px;

            td {
                padding-left: 20px;
            }
        }

        tr:nth-child(odd) {
            background-image: linear-gradient(to right, #e6f3ff, #fff);
        }
        tr:nth-child(even) {
            background-image: linear-gradient(to right, #F5FAFF, #fff);
        }
    }


}</style>



// WEBPACK FOOTER //
// src/components/page/antape.vue